import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-secure-act',
    templateUrl: './secure-act.component.html',
    styleUrls: ['./secure-act.component.scss']
})
export class SecureActComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
